import { Outlet } from "react-router-dom";

export default function Stock() {
  return <Outlet />;
}
